import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Settings, UserCog, Upload } from 'lucide-react';
import ConfiguracoesGerais from './ConfiguracoesGerais';
import ConfiguracoesPerfil from './ConfiguracoesPerfil';
import ConfiguracoesImportacao from './ConfiguracoesImportacao';

const Configuracoes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Determinar a aba ativa baseada na URL
  const getActiveTab = () => {
    if (location.pathname.includes('/configuracoes/perfil')) {
      return 'perfil';
    }
    if (location.pathname.includes('/configuracoes/importar')) {
      return 'importar';
    }
    return 'gerais';
  };

  const [activeTab, setActiveTab] = useState(getActiveTab());

  useEffect(() => {
    setActiveTab(getActiveTab());
  }, [location.pathname]);

  const tabs = [
    {
      id: 'gerais',
      name: 'Gerais',
      icon: Settings,
      path: '/configuracoes/gerais',
      component: ConfiguracoesGerais
    },
    {
      id: 'perfil',
      name: 'Perfil',
      icon: UserCog,
      path: '/configuracoes/perfil',
      component: ConfiguracoesPerfil
    },
    {
      id: 'importar',
      name: 'Importar',
      icon: Upload,
      path: '/configuracoes/importar',
      component: ConfiguracoesImportacao
    }
  ];

  const handleTabChange = (tab) => {
    setActiveTab(tab.id);
    navigate(tab.path);
  };

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow">
        <div className="px-6 py-4">
          <h1 className="text-2xl font-bold text-gray-900">Configurações</h1>
          <p className="text-gray-600 mt-1">
            Gerencie as configurações do sistema e perfis de usuário
          </p>
        </div>
        
        {/* Tabs */}
        <div className="border-t border-gray-200">
          <nav className="flex space-x-8 px-6">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabChange(tab)}
                  className={`flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="h-5 w-5 mr-2" />
                  {tab.name}
                </button>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default Configuracoes;



